import { useContext } from 'react';
import { DayView } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';
import { SchedulerContext } from '../../SchedulerContext';

const useStyles = makeStyles()(() => ({
  hideDayViewTitles: {
    display: 'none',
  },
}));

export const DayScaleRowComponentCustom = (props: DayView.RowProps) => {
  const { classes, cx } = useStyles();
  const schedulerContext = useContext(SchedulerContext);

  return (
    <DayView.DayScaleRow
      className={cx({
        [classes.hideDayViewTitles]: schedulerContext.overView,
      })}
      {...props}
    ></DayView.DayScaleRow>
  );
};
